import { render, staticRenderFns } from "./Radioboxs.vue?vue&type=template&id=877dcd2a"
import script from "./Radioboxs.vue?vue&type=script&lang=js"
export * from "./Radioboxs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports